import axios from 'axios'

const esc = encodeURIComponent

function qs(params) {
  return (
    Object
    .keys(params)
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&')
  )
}

export function toUrlEncoded(data) {
  const params = new URLSearchParams()
  for (var key in data) {
      if (data.hasOwnProperty(key)) {
          params.append(key, data[key])
      }
  }
  return params
}

export function post(uri, data, options = {}) {
  return axios.post(uri, data, options)
}

export function get(uri, data = {}, options = {}) {
  if (Object.keys(data).length > 0) {
    uri = `${uri}?${qs(data)}`
  }
  return axios.get(uri, options)
}
